/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { useForm } from 'react-hook-form'
import { joiResolver } from '@hookform/resolvers/joi'
import { Button, Spinner } from '@chakra-ui/react'
import { validationSchema } from './handlers'
import LicensingFieldsForHookForm from '@/components/forms/predefined/LicensingFieldsForHookForm'
import FormWrapper from '@/components/forms/FormWrapper'

const BuildLicenseTerms = ({
  asset,
  buildLicenseListingTerms,
  className = '',
  hasAlert = false,
  isLoading = false,
  onSubmit,
  onUnlist,
  wrapperClassName = ''
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    resolver: joiResolver(validationSchema),
    defaultValues: {
      minimumPrice: buildLicenseListingTerms?.minimumPrice || undefined,
      requiredRoyalty: buildLicenseListingTerms?.requiredRoyalty || undefined,
      numberOfLicenses: buildLicenseListingTerms?.numberOfLicenses || undefined,
      usageLimit: buildLicenseListingTerms?.usageLimit || undefined,
      usageFee: buildLicenseListingTerms?.usageFee || undefined,
      licenseTerm: buildLicenseListingTerms?.licenseTerm || undefined
    }
  })

  const curOnSubmit = async data => {
    onSubmit && onSubmit({ data })
  }

  if (isLoading) {
    return (
      <div className="text-center flex-auto">
        <Spinner size="xl" />
      </div>)
  }

  return (
    <FormWrapper
      hasAlert={hasAlert}
      className={wrapperClassName}
    >
      <h2 className="text-xl font-semibold mb-4">Build License Listing Terms</h2>
      <form onSubmit={handleSubmit(curOnSubmit)} className={`${className}`}>
        <div className="flex-col border p-4 max-w-2xl bg-white">
          <LicensingFieldsForHookForm
            errors={errors}
            register={register}
          />
        </div>
        <div className="flex space-x-2 mt-4">
          <Button type="submit">List Asset/Update Listing</Button>
          { asset.listed &&
            <Button
              type="button"
              bg="red.500"
              color="white"
              _hover={{ bg: 'red.600' }}
              onClick={onUnlist}
            >
              Unlist Asset
            </Button>
          }
        </div>
      </form>
    </FormWrapper>
  )
}

export default BuildLicenseTerms
